// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const ShipToLocation = t.struct({
    city: t.String,
    country: t.String,
    courierAccountNumber: t.String,
    courierName: t.String,
    id: t.String,
    name: t.String,
    postalCode: t.String,
    state: t.String,
    street1: t.String
}, {
    name: 'ShipToLocation',
    strict: true
});

export const getDefaultState = () => new ShipToLocation({
    city: '',
    country: '',
    courierAccountNumber: '',
    courierName: '',
    id: '',
    name: '',
    postalCode: '',
    state: '',
    street1: ''
});

export default ShipToLocation;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/ship-to-location.js